// Profile of Alina Tselinina, Bulgarian. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina е софтуерен инженер с опит в инженерията на данни, приложната математика и машинното обучение. В момента работи по приложения, базирани на изкуствен интелект, и по агентни системи. Тя има опит в изграждането на API и конвейери за данни, модернизирането на приложения чрез миграция към облака и разработването на услуги, базирани на ML. Фокусът ѝ е свързването на LLM и ИИ агенти с надеждни софтуерни системи чрез структурирани работни процеси, интеграции, тестване и итеративна оценка.',
  imageAlt: 'Портрет на Alina Tselinina',
  personal: {
    languages: 'Английски, полски',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Обучение: финансова и актюерска математика',
      institution: 'Университет „Адам Мицкевич“, Познан',
      degree: 'Степен: магистър'
    },
    {
      period: '2009 - 2014',
      field: 'Обучение: математика',
      institution: 'Беларуски държавен университет, Минск',
      degree: 'Степен: бакалавър'
    }
  ],
  skills: [
    {
      title: 'Програмиране',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'ИИ и LLM',
      description: 'Claude, MCP, ИИ агенти, адаптиране на LLM, обучение и оценка на модели'
    },
    {
      title: 'Облак и данни',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Фреймуърци и API',
      description: 'FastAPI, Flask, Shiny, REST API, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Инженерия на данни и DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Бази данни и оркестрация',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Инструменти на Atlassian',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'от март 2026 г.',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Разработване на ИИ агенти, конфигуриране на работни процеси и интегриране на инструменти.',
        'Адаптиране на LLM, обучение и оценка на модели.',
        'Разработване и интегриране на приложения, базирани на изкуствен интелект.',
        'Квантови изчисления: принос към разработването на софтуер за квантови приложения.'
      ]
    },
    {
      period: 'от май 2025 г.',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'Разработване на приложения.',
        'Реализиране на модулни тестове и UI тестове в подкрепа на качеството на приложенията.'
      ]
    },
    {
      period: 'ноември 2022 - февруари 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Поддръжка и подобряване на конвейери за данни и оркестрация на работни процеси.',
        'Разработване на пакети за автоматизиране на отчети.'
      ]
    },
    {
      period: 'юли 2022 - октомври 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Разработване и поддръжка на ETL конвейери.'
      ]
    },
    {
      period: 'март 2022 - юни 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Проектиране и разработване на REST API и бекенд услуги.',
        'Реализиране на бекенд логика за обработка на JSON.'
      ]
    },
    {
      period: 'ноември 2020 - март 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Проектиране и разработване на REST API и бекенд услуги (proof of concept).',
        'Разработване и поддръжка на ETL конвейери.',
        'Модернизиране на локални (on-premise) приложения чрез миграция към AWS и пренаписване на R код на Python.',
        'Валидиране на XML и трансформиране в HTML.',
        'Разработване на уеб приложения.'
      ]
    },
    {
      period: 'май 2020 - ноември 2020',
      title: 'Data Scientist, PSI Polska, Познан',
      description: [
        'Проектиране и разработване на REST API и бекенд услуги с модел за машинно обучение в бекенда.',
        'Разработване на модел за сегментиране на клиенти.'
      ]
    },
    {
      period: 'януари 2019 - април 2020',
      title: 'Advanced Data Scientist, Analyx, Познан',
      description: [
        'Уеб скрейпинг и разработка на пайплайни за данни.',
        'Разработване на уеб приложения.',
        'Моделиране на маркетинг микса.',
        'Оптимизиране на работните процеси.'
      ]
    },
    {
      period: 'май 2018 - декември 2018',
      title: 'Data Scientist, Познан',
      description: [
        'Разработване на ETL процес.',
        'Поддръжка на Bash скриптове.',
        'Клиентска поддръжка и ad hoc анализи.'
      ]
    },
    {
      period: 'април 2017 - април 2018',
      title: 'Junior Analyst, Познан',
      description: [
        'Анализ на данни и създаване на отчети.',
        'Изготвяне на документация и презентации.'
      ]
    }
  ]
};
